function handleIntersection(entries, observer) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('slide-animate');
            // observer.unobserve(entry.target);
        }else{
            entry.target.classList.remove('slide-animate');
        }
    });
}

// Create an Intersection Observer for each target element
function createObserver(target) {
    const targetElement = document.querySelector(target);

    if (targetElement) {
        const observer = new IntersectionObserver(handleIntersection, {
            root: null,
            rootMargin: '0px', // Margin around the root
            threshold: 0
        });

        observer.observe(targetElement);
    }
}